var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_186",
    "data-name": "Ret\\xE2ngulo 186",
    width: 58,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_225",
    "data-name": "Caminho 225",
    d: "M96.94,50.22c.046,2.762.188,5.618.046,8.474a3.6,3.6,0,0,1-1.826,2.8,5.344,5.344,0,0,1-2.762.6l-3.7-.03V38.516a3.922,3.922,0,0,1,2.8-3.324A51.277,51.277,0,0,1,96.9,35l.046,1.17V49.516l-.046.046v.656Z",
    transform: "translate(-88.7 -34.996)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_226",
    "data-name": "Caminho 226",
    d: "M49.4,49.384V38.29a3.964,3.964,0,0,1,2.434-2.856,19.762,19.762,0,0,1,5.758-.234c.046,1.826,0,4.074.046,5.618l.046,14.466c-.234,2.248.6,5.244-2.2,6.508-1.732.89-4.12.328-6.134.514l-.046-.328v-12.6h.094Z",
    transform: "translate(-49.299 -35.09)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_227",
    "data-name": "Caminho 227",
    d: "M49.5,61.932a3.938,3.938,0,0,0,3,1.732c1.5.14,3.512.234,4.542-1.17.7-.75.234-1.732.422-2.762L57.418,58a16.728,16.728,0,0,0-2.668-.046c-.514,1.872.8,3.98-1.31,5a2.482,2.482,0,0,1-1.732-.234c-.8-.188-.374-1.5-1.5-1.17l-.6-.046v.514H49.5Z",
    transform: "translate(-49.5 -57.922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_228",
    "data-name": "Caminho 228",
    d: "M77.446,36.64,77.5,59.16a4.01,4.01,0,0,1-2.294,2.622,18.634,18.634,0,0,1-5.852.328L69.3,38.374a3.366,3.366,0,0,1,1.826-2.668,4.6,4.6,0,0,1,2.434-.6H77.5l-.046,1.544Z",
    transform: "translate(-69.3 -35.104)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_229",
    "data-name": "Caminho 229",
    d: "M77.275,58.186c.046.234,0,.514.046.8a4.758,4.758,0,0,0-4.354.234,2.74,2.74,0,0,0-.7,1.872,2.38,2.38,0,0,0,1.452,1.92,6.574,6.574,0,0,0,3.558-.234,2,2,0,0,1,0,.75H71.939a2.642,2.642,0,0,1-2.06-1.636,2.894,2.894,0,0,1,.422-2.8,2.964,2.964,0,0,1,2.248-.984Z",
    transform: "translate(-69.691 -58.108)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_230",
    "data-name": "Caminho 230",
    d: "M94.263,61.321a15.863,15.863,0,0,0-2.574-.046,12.2,12.2,0,0,0,.046,1.872,6.8,6.8,0,0,0,2.762-.234.876.876,0,0,0,.234-.936C94.823,61.7,94.589,61.469,94.263,61.321Zm-2.482-2.574a4.3,4.3,0,0,0-.046,1.732c.984-.046,2.248.328,2.856-.422.234-.234.046-.75-.046-.984-.7-.552-1.82-.18-2.764-.32Zm5.572,3.838a1.57,1.57,0,0,1-1.17,1.17H89.725l-.238-.034c0-1.872-.046-3.6.046-5.43h4.12c1.31.14,2.762-.422,3.324.8a1.216,1.216,0,0,1-.188,1.31c-.188.328-.6.374-.7.6a1.94,1.94,0,0,1,1.264,1.076Z",
    transform: "translate(-89.475 -58.279)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jcb",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jcb-2",
    "data-name": "jcb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_196",
    "data-name": "Ret\\xE2ngulo 196",
    stroke: "#e7e7e7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_579",
    "data-name": "Grupo 579",
    transform: "translate(15.998 6.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_578",
    "data-name": "Grupo 578",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_562",
    "data-name": "Grupo 562",
    transform: "translate(18.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_561",
    "data-name": "Grupo 561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_560",
    "data-name": "Grupo 560",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_197",
    "data-name": "Ret\\xE2ngulo 197",
    width: 12.968,
    height: 31.788,
    transform: "translate(-2.294 -2.286)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_565",
    "data-name": "Grupo 565",
    transform: "translate(0 0.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_564",
    "data-name": "Grupo 564",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_563",
    "data-name": "Grupo 563",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_198",
    "data-name": "Ret\\xE2ngulo 198",
    width: 13.062,
    height: 31.882,
    transform: "translate(-2.338 -2.372)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_568",
    "data-name": "Grupo 568",
    transform: "translate(0.096 10.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_567",
    "data-name": "Grupo 567",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_566",
    "data-name": "Grupo 566",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_199",
    "data-name": "Ret\\xE2ngulo 199",
    width: 12.688,
    height: 10.534,
    transform: "translate(-2.34 -2.309)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_571",
    "data-name": "Grupo 571",
    transform: "translate(9.366 0.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_570",
    "data-name": "Grupo 570",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_569",
    "data-name": "Grupo 569",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_200",
    "data-name": "Ret\\xE2ngulo 200",
    width: 12.922,
    height: 31.788,
    transform: "translate(-2.388 -2.347)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_574",
    "data-name": "Grupo 574",
    transform: "translate(9.555 10.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_573",
    "data-name": "Grupo 573",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_572",
    "data-name": "Grupo 572",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_201",
    "data-name": "Ret\\xE2ngulo 201",
    width: 12.312,
    height: 10.112,
    transform: "translate(-2.343 -2.356)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_577",
    "data-name": "Grupo 577",
    transform: "translate(18.811 10.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_576",
    "data-name": "Grupo 576",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_575",
    "data-name": "Grupo 575",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_202",
    "data-name": "Ret\\xE2ngulo 202",
    width: 12.546,
    height: 10.206,
    transform: "translate(-2.377 -2.383)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.5ff09fce49f380b965c2e99818c8f295.svg";
export { ForwardRef as ReactComponent };